var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow"},[(_vm.isMarketingNavigation)?_c('NavDesktopMarketing',{attrs:{"items":_vm.items},on:{"login":function($event){return _vm.login()}}}):_vm._e(),(_vm.isAppNavigation)?_c('NavDesktopApp'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }